<template>
  <div>
    <PageBanner title="公司简介" subtitle="广东中泉环保科技有限公司 · 高新技术实力" />
    <section class="page-section">
      <div class="intro-content">
        <b-row class="align-items-center">
          <b-col md="6">
            <div class="intro-content__text">
              <span class="intro-content__tag">源头制造 · 绿色发展</span>
              <h2>广东中泉环保科技有限公司</h2>
              <p>
                随着我国经济飞速发展，环境污染带来的健康问题也成为了重中之重。因此，绿色低碳工业体系是工业实现可持续发展的必然之路，广东中泉环保科技公司应运而生。
              </p>
              <p>
                广东中泉环保科技有限公司是一家集环保设备设计、生产、维护为一体的高新技术企业。公司自成立以来，以娴熟的技术，先进的工艺，严谨的态度和不断创新的理念，在多个领域治理方面积累了丰富的经验，专业为环保设备工程企业提供最专业的环保设备及一站式配套服务。
              </p>
              <p>
                公司主要生产活性炭一体机，活性炭吸附柜，PP材质喷淋塔，气旋混动洗涤塔，脉冲式布袋除尘设备，滤筒除尘器等各类型环保设备及机电设备、废水处理设备、净化设备、除尘设备、不锈钢制品。
              </p>
              <p class="motto-box">
                "以诚为本、以质取信、以品生存"
              </p>
            </div>
          </b-col>
          <b-col md="6" class="mt-4 mt-md-0">
            <div class="intro-content__img-wrap">
              <img :src="firmImg" alt="中泉环保工厂成品交付" class="intro-content__img" />
              <div class="img-badge">自主精工制造</div>
            </div>
          </b-col>
        </b-row>
      </div>
    </section>

    <!-- 资质与荣誉 -->
    <section class="page-section page-section--alt">
      <SectionTitle title="企业实力与资质" subtitle="高品质源自严苛的质检标准与精湛制造工艺" tag="Corporate Qualification" />
      <div class="qualification-box">
        <div class="qualification-card">
          <div class="icon">🥇</div>
          <h4>高新技术实力</h4>
          <p>持有多项环保设备发明及实用新型专利，工艺精湛，设计可靠。</p>
        </div>
        <div class="qualification-card">
          <div class="icon">🛡️</div>
          <h4>严苛出厂检测</h4>
          <p>出厂前经过严苛试水、试压检测，精益求精，确保产品稳定耐用、无渗漏隐患。</p>
        </div>
        <div class="qualification-card">
          <div class="icon">⭐</div>
          <h4>一站式整体方案</h4>
          <p>从项目工况测量、非标定制设计、自主生产装配到售后维护一站式配套。</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import { COMPANY } from '@/constants/company'

export default {
  name: 'IntroduceView',
  components: { PageBanner, SectionTitle },
  data () {
    return {
      company: COMPANY,
      firmImg: ''
    }
  },
  created () {
    // 采用高品质不锈钢环保设备照片
    this.firmImg = require('@/assets/photos/hero-9.jpg')
  }
}
</script>

<style lang="scss" scoped>
.intro-content {
  text-align: left;

  &__tag {
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--color-primary);
    text-transform: uppercase;
    letter-spacing: 0.1em;
    display: inline-block;
    margin-bottom: 0.5rem;
  }

  h2 {
    font-size: 2rem;
    font-weight: 700;
    color: var(--color-dark);
    margin-bottom: 1.5rem;
  }

  &__text {
    p {
      line-height: 1.8;
      color: var(--color-text-muted);
      margin-bottom: 1.25rem;
      font-size: 1.02rem;
      text-align: justify;
    }

    .motto-box {
      font-size: 1.15rem;
      font-weight: 700;
      color: var(--color-primary-dark);
      background: var(--color-primary-light);
      padding: 1rem 1.5rem;
      border-left: 4px solid var(--color-primary);
      border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
      margin-top: 1.5rem;
    }
  }

  &__img-wrap {
    position: relative;
    border-radius: var(--radius-md);
    overflow: hidden;
    box-shadow: var(--shadow-lg);

    .img-badge {
      position: absolute;
      bottom: 1.25rem;
      right: 1.25rem;
      background: rgba(6, 78, 59, 0.85);
      backdrop-filter: blur(4px);
      color: #fff;
      padding: 0.5rem 1rem;
      font-weight: 600;
      font-size: 0.85rem;
      border-radius: 4px;
      border: 1px solid rgba(255, 255, 255, 0.2);
    }
  }

  &__img {
    width: 100%;
    max-height: 27.5rem;
    object-fit: cover;
    transition: transform 0.4s ease;

    &:hover {
      transform: scale(1.02);
    }
  }
}

.qualification-box {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  padding: 0 1.5rem;

  .qualification-card {
    background: #fff;
    padding: 2.5rem 2rem;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    border: 1px solid var(--color-border);
    text-align: center;
    transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);

    &:hover {
      transform: translateY(-4px);
      box-shadow: var(--shadow-md);
      border-color: var(--color-primary);
    }

    .icon {
      font-size: 2.5rem;
      margin-bottom: 1.25rem;
    }

    h4 {
      font-size: 1.2rem;
      font-weight: 700;
      color: var(--color-dark);
      margin-bottom: 0.75rem;
    }

    p {
      font-size: 0.9rem;
      color: var(--color-text-muted);
      line-height: 1.6;
      margin: 0;
    }
  }
}

@media (max-width: 768px) {
  .qualification-box {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 0;
  }
}
</style>
